var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateNewBannerTemplateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "create-new-page-svgrepo-com",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.841,
    height: 12,
    viewBox: "0 0 13.841 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_173615",
    "data-name": "Group 173615"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_105",
    "data-name": "Union 105",
    d: "M.461,12A.462.462,0,0,1,0,11.539V2.433a.462.462,0,0,1,.461-.461H7.455a.461.461,0,1,1,0,.923H.924v8.183H10.946V6.355a.462.462,0,0,1,.924,0v5.184a.463.463,0,0,1-.462.461ZM2.8,8.611a.461.461,0,0,1,0-.923H9.07a.461.461,0,0,1,0,.923Zm0-2.327a.462.462,0,0,1,0-.924H7.289a.462.462,0,0,1,0,.924ZM10.946,4.4V2.895H9.437a.461.461,0,0,1,0-.923h1.51V.462a.462.462,0,0,1,.924,0v1.51h1.51a.461.461,0,0,1,0,.923H11.87V4.4a.462.462,0,0,1-.924,0Z",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateNewBannerTemplateIcon);
export default __webpack_public_path__ + "static/media/createNewBannerTemplateIcon.dd9b373d624d11b96d0993cbaf4eaa71.svg";
export { ForwardRef as ReactComponent };